import React from 'react';
import { Box, Button } from '@mui/material';
import FileUploadZone from './FileUploadZone';
import FileList from './FileList';

interface FileUploaderProps {
  files: File[];
  setFiles: (files: File[]) => void;
  onNext?: () => void;
  showNextButton?: boolean;
  acceptedFileTypes?: string[];
  practice?: string;
  jobNumber?: string;
}

export default function FileUploader({ files, setFiles, onNext, showNextButton = true, acceptedFileTypes, practice, jobNumber }: FileUploaderProps) {
  const handleFilesSelected = (newFiles: File[]) => {
    setFiles([...files, ...newFiles]);
  };

  const handleRemoveFile = (index: number) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  return (
    <Box>
      <FileUploadZone 
        onFilesSelected={handleFilesSelected} 
        acceptedFileTypes={acceptedFileTypes}
        practice={practice}
        jobNumber={jobNumber}
      />
      
      <Box sx={{ mt: 3, mb: 3 }}>
        <FileList files={files} onRemoveFile={handleRemoveFile} />
      </Box>

      {showNextButton && (
        <Button 
          variant="contained" 
          size="large"
          onClick={onNext} 
          disabled={files.length === 0}
        >
          Next: Configure Workflow
        </Button>
      )}
    </Box>
  );
}
